import { ref } from '@vue/composition-api'

// NOTE: feature flag のユーザー単位での切替を管理する。
// 既存の useCurrentData.js と同様、singleton ref + localStorage 永続化パターン。
// バックエンド側に flag 機構が整備されたら、この composable のみ差し替えればよい。

const STORAGE_KEY = 'featureFlags'

const DEFAULT_FLAGS = {
  // 卓作成ステップ方式ウィザード（既存 TableCreateDrawer と置き換え可能）
  useTableCreateWizard: false,

  // 卓詳細ドロワー概要タブの3カラムレイアウト（OFFで従来の1カラム表示）
  // TODO(3カラム移行完了後に撤去): 新3カラムを本番で検証しOKになったら、
  //   このフラグ / LegacyOverview.vue / 旧 ExtensionCandidateCourses.vue / 旧 CourseHistories.vue を削除し、
  //   Overview.vue を唯一の実装にする（延長候補・コース履歴ロジックの二重保持を解消）。
  //   それまではLegacy側はバグ修正のみとし、新機能は新composable側に寄せる。
  useTableOverview3Column: false,
}

const parseStored = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    const parsed = raw ? JSON.parse(raw) : {}

    return { ...DEFAULT_FLAGS, ...parsed }
  } catch (_) {
    return { ...DEFAULT_FLAGS }
  }
}

const flags = ref(parseStored())

export const setFeatureFlag = (key, value) => {
  flags.value = { ...flags.value, [key]: Boolean(value) }
  localStorage.setItem(STORAGE_KEY, JSON.stringify(flags.value))
}

export const setFeatureFlags = next => {
  const merged = { ...DEFAULT_FLAGS, ...(next || {}) }
  flags.value = merged
  localStorage.setItem(STORAGE_KEY, JSON.stringify(merged))
}

export default () => ({
  flags,
})
